// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue/dist/vue.js'
import App from './App'
import VueRouter from 'vue-router'
import routes from '@/vue/router/routes'
import VueResource from 'vue-resource'
import './vue/filters'
import UUID from 'vue-uuid'

Vue.use(UUID)


Vue.use(VueRouter);
Vue.use(VueResource)

const router = new VueRouter({
  routes: routes,
});

// Moment translate
const moment = require('moment')
require('moment/locale/es')
Vue.use(require('vue-moment'), {
  moment
})


Vue.http.options.root = 'https://solutions.fusepong.com/api/';
// Vue.http.options.root = 'https://newsolutions.fusepong.com/api/';
// Vue.http.options.root = 'https://staging.fusepong.com/api/';
// Vue.http.options.root = 'http://localhost:4000/api/';
// Vue.http.options.root = 'http://192.168.0.78:3000/api/';

Vue.http.headers.common['Access-Control-Allow-Origin'] = '*'
Vue.http.headers.common['Accept-Language'] = 'es'
Vue.http.headers.common['Access-Control-Allow-Methods'] = 'GET, POST, PATCH, PUT, DELETE, OPTIONS'
Vue.http.headers.common['Access-Control-Allow-Headers'] = 'Origin, Content-Type, Authentication, Accept-Language'
Vue.http.headers['Access-Control-Max-Age'] = '1728000'




Vue.mixin({
  methods: {
    encrypt(data) {
      let CryptoJS = require("crypto-js");
      let payload = "G7qeaR2Yb4DAgk92ZQHdjQ==|gfYvWJ0vVdX142/xpsGPW8Fsgc/dGeQPFtaazcUMjQo=|VF/bl6Ae5CVTtQTPCrmAgQ==".split("|");
      let iv = payload[0], hmac = payload[1], cipherText = payload[2];
      let passphraseDgst = CryptoJS.SHA256("ImAwesomeAndHappy").toString();
      let key = passphraseDgst;
      let encrypted = CryptoJS.AES.encrypt(
        JSON.stringify(data),
        CryptoJS.enc.Hex.parse(passphraseDgst),
        {iv:CryptoJS.enc.Base64.parse(iv)}
      );
      return encrypted
    },

    decrypt_info(data){
      let CryptoJS = require("crypto-js");
      let iv = CryptoJS.enc.Base64.parse("kT+uMuPwUk2LH4cFbK0GiA==")
      let key = CryptoJS.enc.Hex.parse("6476b3f5ec6dcaddb637e9c9654aa687")
      let decrypted_value = CryptoJS.AES.decrypt(data,  key,  {mode: CryptoJS.mode.CBC,  iv : iv}).toString(CryptoJS.enc.Utf8)
      return JSON.parse(decrypted_value);
    },
    convertDaytimeFormatToHour(hour){
      let arr=hour.split(":")
      let hours=Number(arr[0])
      let secondArr=arr[1].split(" ")
      let minutes=secondArr[0]
      let amOrPm=secondArr[1]
      let finalHour=[hours,minutes]

      if(amOrPm=="pm" && hours!=12){
        finalHour[0]= (Number(hours)+12)%24
      }else if(hours==12 && amOrPm=="am" ){
        finalHour[0]=0
      }
      return finalHour[0].toString().padStart(2,"0")+":"+finalHour[1].toString().padStart(2,"0");
    },
    shortDate(date){
      let new_date =  date.substring(0,date.indexOf('T'))
      return new_date
    },
  }
})



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: router,
  components: { App },
  template: '<App/>',
})
